import i18n from 'i18next';

export const getLocalizedDateTime = (date: number | Date | undefined): string => {
  const dateFormatter = new Intl.DateTimeFormat(i18n.language === 'ua' ? 'uk' : i18n.language, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const formattedDateTime = dateFormatter.format(date).replace(/,/g, '');

  return formattedDateTime;
};
